var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye")]), _vm._v(" Visualizar FAQ ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-row', {
    staticClass: "justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Pergunta",
      "rows": "1",
      "auto-grow": "",
      "readonly": "",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.content.pergunta,
      callback: function ($$v) {
        _vm.$set(_vm.content, "pergunta", $$v);
      },
      expression: "content.pergunta"
    }
  }), _c('v-textarea', {
    attrs: {
      "label": "Resposta",
      "dense": "",
      "readonly": "",
      "rows": "3",
      "outlined": ""
    },
    model: {
      value: _vm.content.resposta,
      callback: function ($$v) {
        _vm.$set(_vm.content, "resposta", $$v);
      },
      expression: "content.resposta"
    }
  }), _c('v-combobox', {
    attrs: {
      "items": [],
      "chips": "",
      "label": "Palavras-Chave",
      "multiple": "",
      "dense": "",
      "readonly": "",
      "persistent-hint": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          item = _ref.item,
          select = _ref.select,
          selected = _ref.selected;
        return [_c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "close": "",
            "small": ""
          },
          on: {
            "click": select,
            "click:close": function ($event) {
              return _vm.remover(item);
            }
          }
        }, 'v-chip', attrs, false), [_c('strong', [_vm._v(_vm._s(item))]), _vm._v("  ")])];
      }
    }]),
    model: {
      value: _vm.content.palavrasChave,
      callback: function ($$v) {
        _vm.$set(_vm.content, "palavrasChave", $$v);
      },
      expression: "content.palavrasChave"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v(" Fechar ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }